<div class="timesheet-container container main-font h-100">
  <div class="user-list-container" *ngIf="userRole != 'user' || isScrum">
    <div class="search-container">
      <i class="icons search fill-svg-grey-600"></i>
      <input
        type="text"
        placeholder="Cerca"
        class="my-input"
        [formControl]="search" />
    </div>
    <div
      class="d-flex justify-content-end align-items-center w-100 gap-2"
      *ngIf="countUsersWithRequest() || countUsersWithIncorrectDays()">
      <div class="d-flex align-items-center" *ngIf="countUsersWithRequest()">
        <i
          nz-tooltip
          nzTooltipTitle="Richieste TS"
          class="icons bell-request fill-svg-orange-300 mb-1">
        </i>
        <p class="mb-0 text-days-off-notification text-requests ms-1">
          {{ countUsersWithRequest() }}
        </p>
      </div>
      <div
        class="d-flex align-items-center incorrect-days"
        *ngIf="countUsersWithIncorrectDays()">
        <i
          nz-tooltip
          nzTooltipTitle="TS da verificare"
          class="icons error fill-svg-red-600"></i>
        <p class="mb-0 text-days-off-notification text-missing-hours">
          {{ countUsersWithIncorrectDays() }}
        </p>
      </div>
    </div>
    <div class="user-list my-scrollbar">
      <button
        class="user-container align-items-center transparent-btn"
        [ngClass]="indexUserSelected == i ? 'selected' : ''"
        (click)="changeUserSelected(user, i)"
        *ngFor="let user of usersSelect; let i = index">
        <div class="d-flex gap-1 align-items-center">
          <img
            [src]="_utilityService.getSanitizeUrl(user?.path)"
            [alt]="user.first_name"
            class="user-image"
            [class.part-time-avatar]="user.is_part_time" />
          <div class="d-flex flex-column align-items-start">
            <p class="mb-0 text-user">
              {{ user.first_name }} {{ user.last_name }}
            </p>
            <span
              class="part-time-chip part-time-chip--inline"
              *ngIf="user.is_part_time">
              Part-Time
            </span>
          </div>
        </div>
        <div class="d-flex align-items-center gap-2">
          <i
            class="icons bell-request fill-svg-orange-300"
            [ngClass]="{ 'opacity-0': user.requests.length == 0 }"></i>
          <div
            class="d-flex align-items-center mt-1"
            *ngIf="user.incorrect_days.length > 0">
            <p class="text-missing-hours mb-0">
              {{ user.incorrect_days.length }}
            </p>
            <p class="mb-0 ms-1 text-days-off">gg</p>
          </div>
        </div>
      </button>
    </div>
  </div>
  <div class="table-container w-100 my-scrollbar">
    <div class="w-100 d-flex align-items-center gap-2">
      <div class="selected-user-avatar-wrapper">
        <img
          [src]="_utilityService.getSanitizeUrl(selectedUser?.path)"
          alt=""
          class="user-reviewed"
          [class.part-time-avatar]="selectedUser?.is_part_time" />
        <span
          class="part-time-chip part-time-chip--selected-avatar"
          *ngIf="selectedUser?.is_part_time">
          Part-Time
        </span>
      </div>
      <div class="d-flex flex-column">
        <p class="mb-0 text-user-reviewed">
          {{ selectedUser?.first_name }} {{ selectedUser?.last_name }}
        </p>
        <p class="mb-0 text-role-reviewed">{{ selectedUser?.role }}</p>
      </div>
    </div>
    <table class="w-100">
      <thead class="w-100 sticky-header">
        <tr class="table-header-row w-100">
          <th class="select-week-container">
            <div class="d-flex flex-column w-100">
              <p class="mb-0">Settimana</p>
              <div class="d-flex align-items-center gap-2">
                <!-- Freccia indietro -->
                <button
                  nz-button
                  nzShape="circle"
                  class="week-nav-btn"
                  (click)="changeWeek(-1)"
                  [disabled]="isPreviousWeekDisabled()">
                  <i class="icons arrow-left fill-svg-grey-600"></i>
                </button>

                <!-- Datepicker -->
                <nz-date-picker
                  [(ngModel)]="selectedDate"
                  (ngModelChange)="onDateChange($event)"
                  nzFormat="dd-MM-yyyy"
                  class="w-100"
                  nzMode="week"
                  nzAllowClear="false"
                  [nzDateRender]="dateRender"
                  [nzDisabledDate]="disabledFutureDates"
                  [nzShowWeekNumber]="false">
                </nz-date-picker>

                <!-- Freccia avanti -->
                <button
                  nz-button
                  nzShape="circle"
                  class="week-nav-btn"
                  (click)="changeWeek(1)"
                  [disabled]="isNextWeekDisabled()">
                  <i class="icons arrow-right fill-svg-grey-600"></i>
                </button>
              </div>
            </div>

            <ng-template #dateRender let-current>
              <div
                [ngClass]="{
                  'highlighted-day-error': isHighlightedError(current),
                  'highlighted-day-request': isHighlightedRequest(current)
                }">
                {{ current.getDate() }}
              </div>
            </ng-template>
          </th>
          <th
            class="d-flex flex-column width-columns"
            *ngFor="
              let column of listOfColumns;
              let first = first;
              let last = last;
              let i = index
            ">
            <div
              class="day-container"
              [ngStyle]="{
                'border-radius': first
                  ? '8px 0px 0px 0px'
                  : last
                    ? '0px 8px 0px 0px'
                    : '0px',
                background: column.is_today ? 'var(--Blue-500)' : ''
              }">
              <!-- HEADER -->
              <div class="d-flex justify-content-between w-100">
                <div class="d-flex flex-column">
                  <p class="mb-0 text-day">{{ column.date | date: 'd' }}</p>
                  <p class="mb-0 text-day-week">{{ column.day_name }}</p>
                </div>

                <div class="d-flex align-items-start">
                  <button
                    *ngIf="
                      incorrectDays.includes(column.date) &&
                      !totaliTimesheet[i]?.is_ignored &&
                      column.date < currentDate &&
                      chosenUser &&
                      !column.isHolidayDay &&
                      !column.isSicknessDay
                    "
                    (click)="
                      canIgnoreIncorrectDay(column) && ignoreDay(column.date)
                    "
                    [disabled]="!canIgnoreIncorrectDay(column)"
                    [nz-tooltip]="getIncorrectDayTooltip(column)"
                    class="d-flex justify-content-center align-items-center"
                    [class.is-disabled]="!canIgnoreIncorrectDay(column)">
                    <span>
                      <img
                        src="assets/images/icon_calendar/white_background_error.svg"
                        alt="Errore" />
                    </span>
                  </button>

                  <button
                    *ngIf="this.chosenUser ? column.note : true"
                    (click)="openModalNote(column.note, column.date)"
                    [disabled]="
                      column.is_part_time_day && !column.is_working_day
                    "
                    nz-tooltip="Note"
                    class="circle-btn note d-flex justify-content-center">
                    <i class="icons note fill-svg-blue-700"></i>
                  </button>
                  <button
                    (click)="
                      openModalTimesheetRequest(column.date, false, column.note)
                    "
                    *ngIf="
                      column.can_request &&
                      !chosenUser &&
                      !column.isHolidayDay &&
                      !column.isSicknessDay
                    "
                    class="transparent-btn d-flex align-items-center">
                    <i class="icons add fill-svg-grey-0"></i>
                  </button>

                  <button
                    (click)="
                      openModalTimesheetRequest(column.date, true, column.note)
                    "
                    *ngIf="column.status == 'in_attesa'"
                    class="transparent-btn">
                    <i class="icons bell-request fill-svg-orange-300"></i>
                  </button>
                </div>
              </div>

              <!-- BADGE EVENTI CALENDARIO  -->
              <div
                class="calendar-badge permission"
                *ngIf="column.hourlyLeaveHoursForDay > 0">
                <span class="hours-badge__icon">
                  <img
                    src="assets/images/icon_calendar/permission.svg"
                    alt="Ore mancanti" />
                </span>

                <span class="hours-badge__text">
                  {{ column.hourlyLeaveHoursForDay }} ore
                </span>
              </div>

              <div class="calendar-badge sickness" *ngIf="column.isSicknessDay">
                <span>
                  <img
                    src="assets/images/icon_calendar/sickness.svg"
                    alt="Malattia" />
                </span>
                <span class="sickness-badge__text"> Malattia </span>
              </div>

              <div class="calendar-badge holiday" *ngIf="column.isHolidayDay">
                <span>
                  <img
                    src="assets/images/icon_calendar/vacation.svg"
                    alt="Malattia" />
                </span>
                <span class="holiday-badge__text"> Ferie </span>
              </div>

              <!-- Stato ignorato / Part Time -->
              <div
                class="parttime-badge"
                *ngIf="
                  totaliTimesheet[i]?.is_ignored &&
                  column.date <= currentDate &&
                  column.is_part_time_day
                ">
                <i class="icons clock fill-svg-green-600"></i>
                <span class="parttime-text">
                  {{ getPartTimeBadgeLabel(column.expected_minutes) }}
                </span>
              </div>
            </div>
            <div
              class="detail-container"
              [ngStyle]="{
                'border-right': last ? '1px solid var(--Grey-200)' : '0px',
                'border-bottom':
                  projects.length == 0 ? '1px solid var(--Grey-200)' : ''
              }">
              <div class="d-flex flex-column align-items-center w-50">
                <i class="icons scrum fill-svg-grey-600"></i>
                <p class="mb-0 text-detail">Capacity</p>
              </div>
              <div class="d-flex flex-column align-items-center w-50">
                <i class="icons billing fill-svg-grey-600"></i>
                <p class="mb-0 text-detail">Fatt.</p>
              </div>
            </div>
          </th>
        </tr>
      </thead>
      <tbody class="w-100">
        <tr
          class="w-100 table-row-body"
          *ngFor="
            let project of projects;
            let i = index;
            let firstProject = first;
            let lastProject = last
          ">
          <td
            class="project-cell"
            [ngStyle]="{
              'border-radius': firstProject ? '8px 0px 0px 0px' : '',
              'border-top': firstProject ? '1px solid var(--Grey-200)' : ''
            }">
            <div class="d-flex align-items-center gap-2">
              <img
                [src]="_utilityService.getSanitizeUrl(project?.path)"
                alt=""
                class="project-img" />
              <p class="mb-0 text-project">{{ project.alias }}</p>
            </div>
          </td>
          <td
            class="project-cell-hours"
            [ngStyle]="{
              'border-right': lastDay ? '1px solid var(--Grey-200)' : '0px',
              'border-top': firstProject ? '1px solid var(--Grey-200)' : ''
            }"
            *ngFor="let day of project.days; let lastDay = last; let j = index">
            <div class="input-container">
              <div
                class="input-time-picker"
                [ngClass]="{
                  'border-pending': day.status == 'in_attesa',
                  'disabled-day': day.isBlocked
                }">
                <div
                  class="w-50"
                  [ngClass]="{
                    value: day.date != currentDate && day.date < currentDate,
                    'value-current': day.date == currentDate
                  }">
                  <nz-time-picker
                    [nzDisabled]="
                      isDayBlocked(day) || !day.value || !day.is_authorized
                    "
                    [(ngModel)]="day.value"
                    [nzDisabledHours]="disabledHours"
                    [nzDisabledMinutes]="disabledMinutes"
                    (nzOpenChange)="onTimePickerOpenChange($event, day.value)"
                    (ngModelChange)="
                      changeTime(
                        $event,
                        project.id,
                        chosenUser!,
                        day.date,
                        'value',
                        i,
                        j
                      )
                    "
                    [nzMinuteStep]="15"
                    nzFormat="HH:mm"
                    nzPlaceHolder=" "
                    [nzNowText]="' '"
                    [nzOkText]="'Salva'"
                    [nzAllowEmpty]="false"></nz-time-picker>
                </div>

                <nz-time-picker
                  class="w-50"
                  [nzDisabled]="
                    isDayBlocked(day) || !day.value || !day.is_authorized
                  "
                  [(ngModel)]="day.billing_value"
                  [nzDisabledHours]="disabledHours"
                  [nzDisabledMinutes]="disabledMinutes"
                  (nzOpenChange)="
                    onTimePickerOpenChange($event, day.billing_value)
                  "
                  (ngModelChange)="
                    changeTime(
                      $event,
                      project.id,
                      chosenUser!,
                      day.date,
                      'billing_value',
                      i,
                      j
                    )
                  "
                  [nzMinuteStep]="15"
                  nzFormat="HH:mm"
                  nzPlaceHolder=" "
                  [nzNowText]="' '"
                  [nzOkText]="'Salva'"
                  [nzAllowEmpty]="false"></nz-time-picker>
              </div>
            </div>
          </td>
        </tr>

        <!-- TOTALI -->
        <tr class="table-row-body" *ngIf="totaliTimesheet.length > 0">
          <td class="project-cell-totals">
            <p class="mb-0 text-totals">Totali</p>
          </td>
          <td
            class="project-cell-hours-totals"
            [ngStyle]="{
              'border-radius': last ? '0px 0px 8px 0px' : '',
              'border-right': last ? '1px solid var(--Grey-200)' : '',
              background: getBackgroundCellHours(dayTotal.date)
            }"
            *ngFor="
              let dayTotal of totaliTimesheet;
              let last = last;
              let i = index
            ">
            <img
              *ngIf="dayTotal.date < currentDate"
              class="position-absolute position-svg"
              [src]="
                incorrectDays.includes(dayTotal.date)
                  ? 'assets/images/new-icon/error-timesheet.svg'
                  : 'assets/images/new-icon/check-timesheet.svg'
              "
              alt="" />
            <div class="input-time-picker">
              <p
                class="mb-0 text-total pills pills-value"
                [ngClass]="{ 'pills-today': dayTotal.date === currentDate }">
                {{ dayTotal.value }}
              </p>
              <p
                class="mb-0 text-total pills"
                [ngClass]="{ 'pills-today': dayTotal.date === currentDate }">
                {{ dayTotal.billing_value }}
              </p>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <p class="w-100 text-center mb-0 py-3" *ngIf="projects.length == 0">
      {{
        chosenUser
          ? "L'utente selezionato non ha progetti con sprint in corso"
          : 'Non hai progetti con sprint in corso'
      }}
    </p>
  </div>
</div>
